<template>
    <footer class="section-block block-invert s-footer">
        <div class="container">
            <nav class="footer-nav text-center">
                <social-icons :sitesettings="sitedata.settings[0]" class="social-links-big mb-0"/>
                <ul class="list-inline mt-4 mb-4">
                    <li v-if="onepager" class="list-inline-item nav-item-home">
                        <a v-if="mainpageid == 'home'" class="nav-item nav-link scroll active" :href="urlprefix" v-scroll-to="'#top'">Home</a>
                        <a v-else class="nav-item nav-link" :href="'/'">Home</a>
                    </li>
                    <li v-else class="list-inline-item nav-item-home"><a :class="{'active': $route.params.pageslug == null}" class="nav-item nav-link scroll" :href="urlprefix">Home</a></li>
                    <li v-if="onepager" class="list-inline-item" v-for="menuitem in menupages" :class="'nav-item-'+menuitem.pageslug">
                        <a v-if="mainpageid == 'home'" class="nav-item nav-link scroll" :href="urlprefix+menuitem.pageslug" v-scroll-to="'#'+menuitem.pageslug">{{ menuitem.pagetitle }}</a>
                        <a v-else class="nav-item nav-link " :href="urlprefix+menuitem.pageslug">{{ menuitem.pagetitle }}</a>
                    </li>
                    <li v-if="!onepager" class="list-inline-item" v-for="menuitem in menupages" :class="'nav-item-'+menuitem.pageslug">
                        <a class="nav-item nav-link" :class="{'active': $route.params.pageslug == menuitem.pageslug}" :href="urlprefix+menuitem.pageslug">{{ menuitem.pagetitle }}</a>
                    </li>
                </ul>
                <ul v-if="footerpages.length > 0 || creatoreditor" class="list-inline mb-4">
                    <li v-for="footeritem in footerpages" class="list-inline-item nav-item-home">
                        <a v-if="creatoreditor" class="nav-item nav-link" :href="'/creator/'+websiteid+'/'+footeritem.pageslug" :class="{'active': $route.params.pageslug == footeritem.pageslug}" >{{footeritem.pagetitle}}</a>
                        <a v-else class="nav-item nav-link" :href="'/'+footeritem.pageslug" :class="{'active': $route.params.pageslug == footeritem.pageslug}" >{{footeritem.pagetitle}}</a>
                        <a v-if="!readonly" href="#" class="remove_menu_item" @click.prevent="showModal = true, removepage = footeritem._id" ><span class="ico material-icons">cancel</span></a>
                    </li>

                    <li class="list-inline-item nav-item-home">
                        <span class='mainnavitem' v-if="!readonly"><!-- adding new page -->
                            <span class="edited_content" v-if="!editmode">
                                <a class="edit_icon edit_icon_menu" @click.prevent="editmode = true" href="#"><span class="ico material-icons">add_circle</span></a>
                            </span>
                            <span class="edit_field" v-if="editmode">
                                <form id="edit_pagetext" method="post" @submit.prevent="createPage()">
                                    <input class="textinput" type="text" v-model="pagetitle" autofocus placeholder="Naam van footer link"/>
                                    <button class="btn btn-primary">Opslaan</button>
                                </form>
                            </span>
                        </span>
                    </li>
                </ul>
                <div>
                    <strong>Adres: </strong>
                    <span v-if="readonly" class="edited_content text-muted">
                        {{ sitedata.address }}
                    </span>
                    <inline-editor v-if="!readonly" :editable="sitedata.address" dbentry="address" element="normal"/>
                </div>
                <div class="copyright mt-5">
                <span class="ico material-icons text-muted">copyright</span> 2022</div>
            </nav>
        </div>
        <div class="footereditingoptions">
            <div v-if="!readonly || creatoreditor && userWebsiteId.includes(websiteid)" class="footereditingbuttons">
                <div class="button-with-dropdown d-inline-block">
                    <button class="btn btn-secondary btn-ico" @click.prevent="showmoreblock = !showmoreblock" style="background: rgba(0,0,0,0.6); padding: 7px 7px 5px; margin-right: 10px;"><span class="ico material-icons">more_vert</span></button>
                    <ul class="dropdown-block" v-if="showmoreblock">
                        <li><a class="btn btn-primary" :href="'/creator/'+websiteid+'/settingspage'">Uitgebreide opties</a></li>
                        <li><button class="btn btn-primary" @click="showDeletedItems()">Verwijderde items</button></li>
                        <li><button class="btn btn-primary" @click="logoutUser()">Uitloggen</button></li>
                    </ul>
                </div>
                <button class="btn btn-secondary btn-ico" @click.prevent="toggleView()" style="background: rgba(0,0,0,0.6); padding: 7px 7px 5px; margin-right: 10px;"><span v-if="!readonly" class="ico material-icons">visibility</span><span v-if="readonly" class="ico material-icons">visibility_off</span></button>
            </div>

            <div class="editorcorners"></div>

            <div v-if="!sitedata.isactive">
                <div v-if="!readonly || creatoreditor && userWebsiteId.includes(websiteid)" style="position: fixed; right: 55px; bottom: 13px; z-index: 1050;">
                    <a class="btn btn-success toggle-chat-box" @click.prevent="chatBox = true">KOPEN</a>
                    <div v-if="chatBox" style="position: absolute; width: 300px;right: 0; bottom: 110%; max-height: 500px; overflow: auto;" class="chat-box">
                        <button class="btn btn-link btn-ico" @click.prevent="chatBox = false" style="position: absolute; right: 0px; top: 0px;"><span class="ico material-icons">close</span></button>
                        <form id="chat-form">
                            <div class="chat-block d-block">
                                <div class="chat-bubble chat-bubble--left">Hi, Wil je deze website kopen om meteen te gebruiken?</div>
                                <div class="btn-option" v-if="!iktwijfel"><button class="btn btn-primary" @click.prevent="ikwilwebsite = true, orderinfo.request = 'Wants to buy'">Ja, ik wil deze website!</button></div>
                                <div class="btn-option" v-if="!ikwilwebsite"><button class="btn btn-outline-primary" @click.prevent="iktwijfel = true, orderinfo.request = 'Wants info'" id="inforequest">Ik twijfel nog...</button></div>
                            </div>
                            <transition name="slide">
                                <div class="chat-block" v-if="ikwilwebsite">
                                    <div class="chat-bubble chat-bubble--left">Hoe wil je dat wij contact opnemen?</div>
                                    <div class="btn-option" v-if="!mailmij"><button class="btn btn-primary" @click.prevent="belmij = true, orderinfo.contactby = 'Phone'">Bel mij</button></div>
                                    <div class="btn-option" v-if="!belmij"><button class="btn btn-primary" @click.prevent="mailmij = true, orderinfo.contactby = 'Email'">Stuur mij een e-mail</button></div>
                                </div>
                            </transition>
                            <transition name="slide">
                                <div class="chat-block" v-if="iktwijfel">
                                    <div class="chat-bubble chat-bubble--left">Dat begrijpen wij. Jouw website is een belangrijk onderdeel van je bedrijf! Waar twijfel je aan?</div>
                                    <div class="btn-option"><button class="btn btn-primary" @click.prevent="mogelijkheden = true, orderinfo.infoneeded = 'Possibilities'">Aan de mogelijkheden</button></div>
                                    <div class="btn-option"><button class="btn btn-primary" @click.prevent="mogelijkheden = true, orderinfo.infoneeded = 'Price'">Aan de prijs</button></div>
                                </div>
                            </transition>
                            <transition name="slide">
                                <div class="chat-block" v-if="mogelijkheden">
                                    <div class="chat-bubble chat-bubble--left">Wij informeren je graag over meer. Hoe wil je dat wij contact opnemen?</div>
                                    <div class="btn-option" v-if="!mailmij"><button class="btn btn-primary" @click.prevent="belmij = true, orderinfo.contactby = 'Phone'">Bel mij terug</button></div>
                                    <div class="btn-option" v-if="!belmij"><button class="btn btn-primary" @click.prevent="mailmij = true, orderinfo.contactby = 'Email'">Stuur mij een e-mail</button></div>
                                </div>
                            </transition>
                            <transition name="slide">
                                <div class="chat-block" v-if="belmij">
                                    <div class="chat-bubble chat-bubble--left">Op welk nummer mogen wij jou bellen?</div>
                                    <input type="text" id="sale-tel" name="sale-tel" v-model="orderinfo.phonenumber" placeholder="Jouw telefoonnummer" class="form-control mb-2" autofocus/>
                                    <div class="btn-option"><button class="btn btn-primary submit-chat-form" @click.prevent="thanks = true, saveOrderInfo()">Bel mij</button></div>
                                </div>
                            </transition>
                            <transition name="slide">
                                <div class="chat-block" v-if="mailmij">
                                    <div class="chat-bubble chat-bubble--left">Kunnen wij je mailen op <strong id="usergivenemail">Emailadres?</strong>?</div>
                                    <div class="btn-option" v-if="!andermail"><button class="btn btn-primary" @click.prevent="thanks = true, saveOrderInfo()">Ja, graag!</button></div>
                                    <div class="btn-option" v-if="!thanks"><button class="btn btn-primary" @click.prevent="andermail = true">Nee, op een ander adres...</button></div>
                                </div>
                            </transition>
                            <transition name="slide">
                                <div class="chat-block" v-if="andermail">
                                    <div class="chat-bubble chat-bubble--left">Geef een emailadres op:</div>
                                    <input type="text" id="sale-email" name="sale-email" v-model="orderinfo.email" placeholder="Jouw e-mailadres" class="form-control mb-2" autofocus/>
                                    <div class="btn-option"><button class="btn btn-primary submit-chat-form" @click.prevent="thanks = true, saveOrderInfo()">Mail mij</button></div>
                                </div>
                            </transition>
                            <transition name="slide">
                                <div class="chat-block" v-if="thanks">
                                    <div class="chat-bubble chat-bubble--left">Wij nemen meteen contact met je op! Bedankt voor je vertrouwen in Phabsite! Ga gerust verder met aanpassen.</div>
                                    <button class="btn btn-primary sluit-chat" @click.prevent="chatBox = false">Chat sluiten</button>
                                </div>
                            </transition>

                        </form>
                    </div>
                </div>
            </div>
        </div>

        <modal v-if="showDeletedItemsModal" @close="showDeletedItemsModal = false" title="Deleted items">
            <ul class="blocks-compact-list" style="margin: -15px; max-height: calc(100vh - 85px); overflow: auto;">
                <li v-for="n in 8">
                    <span class="review-image" style="float: right; margin: 0;"></span>
                    <!--span class="review-image" :style="'background-image: url('+page.blockimage+')'"></span-->
                    <strong>Block name can be long</strong>
                    <p class="mb-2" style="line-height: 1.5;">Block description can even be much <span style="cursor: pointer;">...</span></p>
                    <p class="mb-2" style="opacity: .6; font-style: italic; font-size: 90%;">This block contains text in columns</p>
                    <button class="btn btn-primary btn-sm mr-2">Restore</button>
                    <button class="btn btn-outline-danger btn-sm" @click.prevent="showModal = true, removepage = 1" >Delete permanently</button>
                </li>
            </ul>
        </modal>

        <modal v-if="showModal" @close="showModal = false" title="Delete page">
            <form @submit.prevent="removePage(removepage)">
                <p>Weet je zeker dat je de pagina en subpagina's wil verwijderen?</p>
                <button class="button" type="submit">Ja, ik weet het zeker</button>
            </form>
        </modal>
    </footer>
</template>

<script>
    import Modal from '../modal/Modal.vue';
    import InlineEditor from '../app/InlineEditor.vue';
    import SocialIcons from './SocialIcons.vue';

    import { userService } from '../../services/user.service.js';
    import { authHeader } from '../../services/auth-header.js';

    import axios from 'axios';

    export default {
        components:{
            InlineEditor,
            SocialIcons,
            Modal
        },
        props:{
            websiteid: String,
            mainpageid: String,
            readonly: Boolean,
            creatoreditor: Boolean,
            creatorhome: Boolean,
            sitedata: Object
        },
        data: function(){
            return{
                onepager: false,
                editmode: false,
                chatBox: false,
                ikwilwebsite: false,
                iktwijfel: false,
                mogelijkheden: false,
                belmij: false,
                mailmij: false,
                andermail: false,
                thanks: false,
                menupages: {},
                footerpages: {},
                pagetitle: '',
                urlprefix: '',
                orderinfo: {},
                showModal: false,
                showDeletedItemsModal: false,
                showmoreblock: false,
                userWebsiteId: JSON.parse(localStorage.getItem('user'))
            }
        },
        methods: {
            toggleView(){
                this.$emit('clicked')

            },
            saveOrderInfo(){
                const requestOptions = {
                    headers: authHeader()
                }

                const data = {
                    websiteid: this.$route.params.websiteid,
                    content: [this.orderinfo]
                }

                axios.patch(process.env.VUE_APP_ROOT_API+'/settings/buy/', data, requestOptions)
                .then(response => {
                    // some response?
                })
            },
            getPages(belongsto){
                axios.get(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/'+belongsto)
                .then(response => {
                    this.menupages = response.data.response
                })
            },
            getFooterPages(belongsto){
                axios.get(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/'+belongsto)
                .then(response => {
                    this.footerpages = response.data.response
                })
            },
            createPage(){
                const requestOptions = {
                headers: authHeader()
                }

                const data = {
                    websiteid: this.websiteid,
                    belongsto: 'footer',
                    pagetitle: this.pagetitle
                }

                axios.post(process.env.VUE_APP_ROOT_API+'/pages/', data, requestOptions)
                .then(response => {
                    this.editmode = false,
                    this.pagetitle = ''
                    this.getFooterPages('footer')
                })
            },
            removePage(id){
                const requestOptions = {
                    headers: authHeader()
                }

                axios.delete(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/pageid/'+id, requestOptions)
                .then(response => {
                    this.showModal = false
                    this.getFooterPages('footer')
                })
            },
            showDeletedItems(){
                this.showDeletedItemsModal = true;
            },
            logoutUser(){
                userService.logout();
                window.location.href = '/';
            }
        },
        mounted(){
            if(!this.creatoreditor){
                this.urlprefix = '/'
            } else {
                this.urlprefix = '/creator/'+this.websiteid+'/'
            }
            this.getFooterPages('footer')
            if(this.sitedata.settings[0].use_one_pager){
                this.urlprefix = '/#'
                this.onepager = true;
                this.getPages('home')
            } else {
                if(!this.creatoreditor){
                    this.urlprefix = '/'
                } else {
                    this.urlprefix = '/creator/'+this.websiteid+'/'
                }
                this.getPages('nav')
            }
        },
        watch: {
            sitedata: {
                handler(sitedata) {
                }
            }
        }

    }
</script>